import { h } from '@stencil/core';

const SelectField = ({ groupProps, selectProps, name, label, noEmptyValue = false, searchable = false, options = [], showBlank = true, validate = {}, scrollToClick, onChange = (_) => null }) => {
  const { ref, unRef, ...restSelectProps } = selectProps(name);

  if (showBlank && !noEmptyValue) {
    options = [{ label: '--Select--', value: '', disabled: true }, ...options];
  }

  return (
    <rentware-select
      {...groupProps(name)}
      {...validate}
      name={name}
      label={label}
      options={options}
      value={restSelectProps.value}
      noEmptyValue={noEmptyValue}
      searchable={searchable}
      inputRef={ref}
      inputUnRef={unRef}
      error={restSelectProps.error}
      scrollToClick={scrollToClick}
      onValueChange={(e) => {
        const value = e.detail.value;
        (e.target as any).value = value;
        restSelectProps.onChange(e);
        restSelectProps.onBlur(e);
        onChange(value)
      }}
      onFocus={restSelectProps.onFocus}
      onBlur={restSelectProps.onBlur}
      wasTouched={restSelectProps.wasTouched}
    />
  );
};

export default SelectField;
